/*
 * File: d:\projects\AutoFiFront\src\Content\MyCart\MyCart.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday February 22nd 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Wednesday February 22nd 2023 11:28:47 am
 * Modified By: the developer formerly known as Jonathan MAZAT at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from 'react';
import CarsDisplay from 'Content/Car/CarsDisplay/CarsDisplay';
import { SingleCarFormat } from 'Content/Car/CarElement/CarElement.type';
import { useLoaderData } from 'react-router-dom';
import style from 'Content/MyCart/MyCart.module.css';
import translator from 'MultiLanguage/TranslationWrapper';

function MyCart(_:any){
    const carsInCart: SingleCarFormat[] = useLoaderData() as SingleCarFormat[];
    const carCount = carsInCart.length;
    return (
        <React.Fragment>
            {
                carsInCart.length > 0 ?
                <h1 className={`${style.titleCart}`}>{translator.decode("cart.carSelectedInCart")} ({carCount}) :</h1>
                :
                <h1 className={`${style.titleCart}`}>{translator.decode("cart.noCarInCart")}</h1>
            }
            <CarsDisplay carList={carsInCart} themeColor={''}/>
        </React.Fragment>
    );
}

export default MyCart;
